<template>
  <div class="w_100 text-center overdue">
    <div class="overdue-header flex flex_center">
      <div class="top_logo">
        <img style="width: 120px;" :src="$store.state.defaultLogo" alt="" />
      </div>

      <span class="version">{{
        `${$translate("versionNumber")}：${
          $store.state.systemConfig.currentVersion
        }`
      }}</span>
    </div>
    <div class="w_100 text-center overdue-content">
      <img src="../../../assets/img/overdue.png" alt="" />

      <div style="margin-top: 2em" v-if="noAuthMessage">
        <p style="font-size: 20px">
          {{ $translate("sorry") }}，{{
            isAdmin ? noAuthMessage : noAuthMessage + $translate("contactAdmin")
          }}
        </p>
        <p style="font-size: 14px;color:#666666">
          {{
            isAdmin
              ? noAuthMessage
              : noAuthMessage + $translate("contactAdmin")
          }}，
          <el-button type="text" @click="goLogout">
            <span style="font-size: 14px">{{ $translate("goBack") }}</span>
          </el-button>
          <span v-if="isAdmin">
            {{ $translate("or") }}
            <el-button type="text" @click="goAuth">
              <span style="font-size: 14px">{{ $translate("goToAuth") }}</span>
            </el-button>
          </span>
        </p>
      </div>
      <div v-if="noUserTypeMessage">
        <p style="font-size: 20px">
          {{ $translate("sorry") }}，{{ noUserTypeMessage }}
        </p>
        {{ outTime }}{{ $translate("second") + $translate("logout") }}
        <el-button type="text" @click="goLogout">
          <span style="font-size: 14px">{{ $translate("goBack") }}</span>
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["noAuthMessage", "noUserTypeMessage"],
  data() {
    return {
      outTime: 10,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.user.isAdmin;
    },
  },
  mounted() {
    if (this.noUserTypeMessage) {
      let timer = null;
      timer = setInterval(() => {
        this.outTime = this.outTime <= 0 ? 0 : this.outTime - 1;
        if (this.outTime <= 0) {
          clearInterval(timer);
          this.goLogout();
        }
      }, 1000);
    }
  },
  methods: {
    goLogout() {
      this.$store.commit("logout");
    },
    goAuth() {
      if (localStorage.clientToken || this.$store.state.clientToken) {
        const token = localStorage.clientToken || this.$store.state.clientToken;
        localStorage.setItem("token", token);
        if (
          localStorage.clientGlobalRole &&
          localStorage.clientGlobalRole != "null" &&
          localStorage.clientGlobalRole !== "undefined"
        ) {
          localStorage.globalRole = localStorage.clientGlobalRole;
        }
        if (localStorage.clientReturnUrl) {
          localStorage.setItem("returnUrl", localStorage.clientReturnUrl);
        }
        if (localStorage.clientisssoout) {
          localStorage.setItem("isssoout", localStorage.clientisssoout);
        }

        const openUrl = this.$getOrigin(
          `/${this.$store.state.adminName}/#/systemSoftwareAuthor`
        );
        window.open(openUrl);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.overdue {
  margin: 3% 10%;
  .overdue-content {
    background-color: #fff;
    padding: 8% 10%;
    height: 80%;
  }
  .version {
    color: #666666;
    font-size: 14px;
  }
}
</style>
